"use client";
import FindacourseWrapper from "@packages/shared-components/course-details/findacourse/findacoursewrapper";
import Subscribecomponents from "@packages/shared-components/common-utilities/newsletter-and-subscription/subscribe-newsletter/subscribecomponents";
import ContentfulPreviewProvider from "@packages/lib/contentful-preview/ContentfulLivePreviewProvider";

const NotFoundPage = () => {
  return (
    <ContentfulPreviewProvider
      locale="en-GB"
      enableInspectorMode={false}
      enableLiveUpdates={false}
      debugMode={false}
    >
      <>
        <div className="max-w-container mx-auto">
          <div className="px-[16px] md:px-[20px] xl:px-0 py-[40px] md:py-[56px]">
            <div className="flex gap-[16px]">
              <div className="flex flex-col gap-[4px]">
                <div className="para-lg font-bold font-farro">
                  Well, that's unexpected!
                </div>
                <div className="small">
                  We couldn't find any matches for{" "}
                  {typeof window !== "undefined" &&
                    window?.location?.pathname
                      ?.split("/")[2]
                      ?.split("-")
                      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(" ")}
                </div>
                <ul className="list-disc small mt-[20px] ml-[20px]">
                  <li>
                    Not what you expected? Try a new search term or check for
                    typos.
                  </li>
                  <li>Let's find what you're looking for!</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <FindacourseWrapper
          clearing={
            process.env.NEXT_PUBLIC_CLEARING_FLAG?.toLocaleLowerCase() === "on"
          }
        />
        <Subscribecomponents pageGrouping="Error Page" />
      </>
    </ContentfulPreviewProvider>
  );
};

export default NotFoundPage;
